<template>
  <div id="project-one-lead-gen-view">
    <h2>ProjectOneGenView.vue</h2>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#project-one-lead-gen-view {
  background-color: darkorange;
  color: white;
  height: 100%;
}
</style>
